import script from "./NotePreview.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotePreview.vue?vue&type=script&setup=true&lang=ts"

import "./NotePreview.vue?vue&type=style&index=0&id=0e79595f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0e79595f"]])

export default __exports__